var _excluded = ["reactive", "minWidth", "maxWidth", "maxChars", "minChars", "charExceededMessage", "icon"];

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Input as AntInput } from 'antd';
import { getClassNames } from '../../utils/getClassNames';

var InputShadow = /*#__PURE__*/function (_React$Component) {
  _inherits(InputShadow, _React$Component);

  var _super = _createSuper(InputShadow);

  function InputShadow() {
    var _this;

    _classCallCheck(this, InputShadow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.container = void 0;
    return _this;
  }

  _createClass(InputShadow, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("span", {
        style: {
          display: 'inline-block',
          opacity: '0',
          overflow: 'hidden',
          width: '0',
          height: '0'
        }
      }, /*#__PURE__*/React.createElement("span", {
        ref: function ref(el) {
          return _this2.container = el;
        },
        style: {
          whiteSpace: 'nowrap'
        },
        className: getClassNames('input-shadow')
      }));
    }
  }]);

  return InputShadow;
}(React.Component);

export var Input = /*#__PURE__*/function (_React$Component2) {
  _inherits(Input, _React$Component2);

  var _super2 = _createSuper(Input);

  function Input() {
    var _this3;

    _classCallCheck(this, Input);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    _this3.state = {};
    _this3.maxMinWidth = 10;
    _this3.defaultMinWidth = 60;
    _this3.defaultMaxWidth = '100%';
    _this3.rootRef = void 0;
    _this3.inputRef = void 0;
    _this3.inputShadowRef = void 0;
    _this3.placeholderShadowRef = void 0;

    _this3.handleTopClick = function (ev) {
      var target = ev.target;

      if (!!target) {
        try {
          var targetCN = target.classList.toString();
          var parentCN = target.parentElement.classList.toString();

          if (/group-addon/.test(targetCN) || /group-addon/.test(parentCN)) {
            return;
          }
        } catch (_err) {}
      }

      if (!_this3.inputRef.input.focused) {
        _this3.inputRef.focus();
      }
    };

    _this3.handleFocus = function (ev) {
      _this3.setState({
        focused: true
      });

      if (!!_this3.props.onFocus) {
        _this3.props.onFocus(ev);
      }
    };

    _this3.handleBlur = function (ev) {
      _this3.setState({
        focused: false
      });

      if (!!_this3.props.onBlur) {
        _this3.props.onBlur(ev);
      }
    };

    _this3.handleChange = function (ev) {
      var value = ev.target.value;

      _this3.calculateWidth(value);

      _this3.setState({
        value: value
      });

      if (!!_this3.props.onChange) {
        _this3.props.onChange(ev);
      }
    };

    return _this3;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateWidth();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _this$props$size,
          _getClassNames;

      var _this$props = this.props,
          reactive = _this$props.reactive,
          minWidth = _this$props.minWidth,
          maxWidth = _this$props.maxWidth,
          maxChars = _this$props.maxChars,
          minChars = _this$props.minChars,
          charExceededMessage = _this$props.charExceededMessage,
          _icon = _this$props.icon,
          props = _objectWithoutProperties(_this$props, _excluded);

      var _this$getInputIcon = this.getInputIcon(),
          icon = _this$getInputIcon.icon,
          iconPlacement = _this$getInputIcon.placement;

      var hasCharLimit = !!this.inputRef && (!!maxChars || !!minChars);
      var isOutsideLimits = false;
      var charLength = 0;

      if (hasCharLimit) {
        charLength = (this.input.value || '').trim().length;

        if (!isOutsideLimits && !!minChars) {
          if (charLength > 0 && charLength < minChars) {
            isOutsideLimits = true;
          }
        }

        if (!isOutsideLimits && !!maxChars) {
          if (charLength > 0 && charLength > maxChars) {
            isOutsideLimits = true;
          }
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this4.rootRef = el;
        },
        className: getClassNames('input', (_getClassNames = {}, _defineProperty(_getClassNames, "size-".concat((_this$props$size = this.props.size) !== null && _this$props$size !== void 0 ? _this$props$size : 'default'), true), _defineProperty(_getClassNames, 'reactive', this.props.reactive), _defineProperty(_getClassNames, "icon-".concat(iconPlacement), !!icon), _defineProperty(_getClassNames, 'focused', this.state.focused), _defineProperty(_getClassNames, 'addon-before', !!this.props.addonBefore), _defineProperty(_getClassNames, 'addon-after', !!this.props.addonAfter), _defineProperty(_getClassNames, 'show-char-count', hasCharLimit), _getClassNames)),
        onClick: this.handleTopClick
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('input-wrapper')
      }, !icon ? undefined : iconPlacement === 'left' && icon, /*#__PURE__*/React.createElement(AntInput, _extends({
        ref: function ref(el) {
          return _this4.inputRef = el;
        }
      }, props, {
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        style: !this.props.reactive ? undefined : _objectSpread(_objectSpread({}, props.style), {}, {
          maxWidth: "".concat(this.props.maxWidth, "px") || this.defaultMaxWidth
        })
      })), !icon ? undefined : iconPlacement === 'right' && icon, /*#__PURE__*/React.createElement(InputShadow, {
        ref: function ref(el) {
          return _this4.inputShadowRef = el;
        }
      }), /*#__PURE__*/React.createElement(InputShadow, {
        ref: function ref(el) {
          return _this4.placeholderShadowRef = el;
        }
      })), hasCharLimit && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('input-char-counter', _defineProperty({}, 'outside-limits', isOutsideLimits))
      }, charLength, " ", charLength === 1 ? 'Character' : 'Characters', isOutsideLimits && !!charExceededMessage ? ". ".concat(charExceededMessage) : ''));
    }
  }, {
    key: "input",
    get: function get() {
      return (this.inputRef || {}).input;
    }
  }, {
    key: "getInputIcon",
    value: function getInputIcon() {
      var icon;
      var placement = 'right';

      if (!!this.props.icon) {
        if (typeof this.props.icon === 'string') {
          icon = /*#__PURE__*/React.createElement(LegacyIcon, {
            type: this.props.icon
          });
        } else if (_typeof(this.props.icon) === 'object' && 'component' in this.props.icon) {
          placement = this.props.icon.placement || placement;

          if (typeof this.props.icon.component === 'string') {
            icon = /*#__PURE__*/React.createElement(LegacyIcon, {
              type: this.props.icon.component
            });
          } else {
            icon = this.props.icon.component;
          }
        } else {
          icon = this.props.icon;
        }
      }

      icon = /*#__PURE__*/React.createElement("span", {
        className: getClassNames('input-icon')
      }, icon);
      return {
        icon: icon,
        placement: placement
      };
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var _this$props$size2;

      return (_this$props$size2 = this.props.size) !== null && _this$props$size2 !== void 0 ? _this$props$size2 : 'default';
    }
  }, {
    key: "calculateWidth",
    value: function calculateWidth(value) {
      if (!this.props.reactive) {
        return;
      }

      var minWidth = this.props.minWidth || this.defaultMinWidth;
      var width = minWidth;
      var phWidth = minWidth;

      if (width < this.maxMinWidth) {
        phWidth = width = this.maxMinWidth;
      }

      var prefixWidth = 0;
      var suffixWidth = 0;

      if (!!this.props.prefix) {
        var prefixRef = this.rootRef.querySelector('.ant-input-prefix');

        if (!!prefixRef) {
          prefixWidth = prefixRef.getBoundingClientRect().width + 14;
        }
      }

      if (!!this.props.suffix) {
        var suffixRef = this.rootRef.querySelector('.ant-input-suffix');

        if (!!suffixRef) {
          suffixWidth = suffixRef.getBoundingClientRect().width;
        }
      }

      var affixWidth = prefixWidth + suffixWidth;
      width += Math.round(affixWidth);
      phWidth += Math.round(affixWidth);

      if (!!this.props.placeholder && this.placeholderShadowRef && this.placeholderShadowRef.container) {
        this.placeholderShadowRef.container.innerHTML = (this.props.placeholder || '').replace(/\s/g, '&nbsp;');
        var shadowWidth = this.placeholderShadowRef.container.getBoundingClientRect().width;
        var augmentedWidth = !shadowWidth ? phWidth : Math.round(shadowWidth) + 2 + affixWidth;

        if (augmentedWidth > minWidth) {
          phWidth = augmentedWidth;
        }
      }

      value = value || this.props.placeholder;

      if (!!value && this.inputShadowRef && this.inputShadowRef.container) {
        this.inputShadowRef.container.innerHTML = (value || '').replace(/\s/g, '&nbsp;');
        var _shadowWidth = this.inputShadowRef.container.getBoundingClientRect().width;

        var _augmentedWidth = !_shadowWidth ? width : Math.round(_shadowWidth) + 2 + affixWidth;

        if (_augmentedWidth > minWidth) {
          width = _augmentedWidth;
        }
      }

      if (this.inputRef) {
        var root = this.rootRef;
        var outer = root.parentNode;
        var basePadding = this.getSize() !== 'small' ? 24 : 19;
        var iconPadding = 17;
        var paddingWidth = basePadding + (this.props.icon ? iconPadding : 0);

        if (!!this.props.maxWidth) {
          if (width >= this.props.maxWidth - paddingWidth) {
            width = this.props.maxWidth - paddingWidth;
          }
        } else {
          if (!!outer) {
            var outerWidth = outer.getBoundingClientRect().width;

            if (width >= outerWidth - paddingWidth) {
              width = outerWidth - paddingWidth;
            }
          }
        }

        this.inputRef.input.style.width = "".concat(width < phWidth ? phWidth : width, "px");
      }
    }
  }]);

  return Input;
}(React.Component);